












import PrivacyLink from '@/models/interfaces/PrivacyLink';
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class PrivacyLinks extends Vue {
  @Prop({
    default: () => [],
  })
  private privacyLinks: PrivacyLink[];

  @Prop()
  private placement: string;

  private href(value: string) {
    return value
      .replace('{email}', String(this.$route?.query.email))
      .replace('{customerId}', String(this.$route?.query.customerId))
      .replace('{phone}', String(this.$route?.query.phone))
      .replace('{transactionId}', String(this.$route?.query.transactionId));
  }

  private validateHref(parameter: PrivacyLink): boolean {
    return !!parameter.href;
  }

  private get links() {
    return this.placement === 'enrichment'
      ? this.privacyLinks.filter((s) => s.placement === 'enrichment')
      : this.privacyLinks.filter((s) => s.placement !== 'enrichment');
  }
}
